
   const productCards = document.querySelectorAll('.product-card-custom');

      productCards.forEach(card => {
        const colorSwatches = card.querySelectorAll('.product-card__swatches .color-swatch');
        const imageSwatches = card.querySelectorAll('.image-swatch');
        const imageMain = card.querySelector('.product-card__image-wrapper .product-card__image');

        colorSwatches.forEach(color => {
          const colorName = color.getAttribute('title');

          color.addEventListener('click', () => {            
            const matchedImage = Array.from(imageSwatches).find(img => {
              const imageName = img.getAttribute('data-image-name');
              return imageName && imageName === colorName;
            });

            if (matchedImage) {
              const newImageUrl = matchedImage.getAttribute('data-image-url');

              if (newImageUrl && newImageUrl.trim() !== '') {
                imageMain.src = newImageUrl;
              }
            }
          });
        });
      });




